import { createContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  ORGANIZATION_SETTIGS_BY_ALIAS,
  OrganizationDetails,
} from "../../constant";
import { Loader } from "../loader";
import { MainLayout } from "../main-layout/MainLayout";

export const ERROR_KEY = "error";
export const ALIAS_KEY = "alias";
export const NO_ALIAS_ERROR = "no-alias";
export const UNKNOWN_ALIAS_ERROR = "unknown-alias";
export const ORGANIZATION_ID_SESSION_STORAGE_KEY = "organizationId";

export const OrganizationDetailsContext = createContext<
  OrganizationDetails | undefined
>(undefined);

/**
 * Ensure organization details (alias) are present before authentication is started.
 */
export const OrganizationDetailsContextHandler = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [organizationDetails, setOrganizationDetails] = useState<
    OrganizationDetails | undefined
  >();
  const navigate = useNavigate();
  const { organizationAlias } = useParams<{
    organizationAlias?: string;
  }>();

  useEffect(() => {
    const alias = organizationAlias?.toLocaleLowerCase();

    if (!alias) {
      navigate(`/?${ERROR_KEY}=${NO_ALIAS_ERROR}`);
      return;
    }

    const organizationDetails = ORGANIZATION_SETTIGS_BY_ALIAS[alias];

    if (!organizationDetails) {
      navigate(`/?${ERROR_KEY}=${UNKNOWN_ALIAS_ERROR}&${ALIAS_KEY}=${alias}`);
      return;
    }

    sessionStorage.setItem(
      ORGANIZATION_ID_SESSION_STORAGE_KEY,
      organizationDetails.id,
    );
    setOrganizationDetails(organizationDetails);
  }, [navigate, organizationAlias]);

  if (!organizationDetails) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  return (
    <OrganizationDetailsContext.Provider value={organizationDetails}>
      {children}
    </OrganizationDetailsContext.Provider>
  );
};
